import { typedQueryClient, useTypedQuery } from "hooks";
import { CustomersQueryKeys } from "modules/CustomersDashboard/queryKeys";

import type { Customer } from "models";

export const useSelectedCustomer = () => ({ selectedCustomer: useTypedQuery({ queryKey: CustomersQueryKeys.selectedCustomer, initialData: null }).data });
export const setSelectedCustomer = (selectedCustomer: Customer | null) => typedQueryClient.setQueryData(CustomersQueryKeys.selectedCustomer, selectedCustomer);
